<nz-header class="table-header">
  <div class="table-header-row margin-lr">
    <div class="table-header-cell">
      {{ "Patient Assessment Card" | translate }}
    </div>
  </div>
</nz-header>

@if (!isLoading) {
  <form
    style="margin-bottom: 10em"
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
  >
    <nz-steps
      [nzCurrent]="current"
      [nzProgressDot]="progressTemplate"
      (nzIndexChange)="onIndexChange($event)"
      [nzDirection]="isLargeScreen ? 'horizontal' : 'vertical'"
    >
      @for (page of pages; track page; let i = $index) {
        <nz-step
          [nzTitle]="page.title"
          [nzDisabled]="disable && i > current"
          [nzDescription]="
            !isLargeScreen && i === current && page.elements
              ? dynamicQuestionsTemplate
              : ''
          "
        />
      }
    </nz-steps>

    <ng-template #dynamicQuestionsTemplate>
      <app-physiotherapy-pac-questions
        [elements]="pages[current].elements"
        [formGroup]="formGroup"
        [readonlyMode]="readonlyMode"
      />
    </ng-template>

    <ng-template
      #progressTemplate
      let-dot
      let-status="status"
      let-index="index"
    >
      <span nz-popover>
        <ng-template [ngTemplateOutlet]="dot"></ng-template>
      </span>
    </ng-template>

    @if (isLargeScreen && pages[current].elements) {
      <app-physiotherapy-pac-questions
        [elements]="pages[current].elements"
        [formGroup]="formGroup"
        [readonlyMode]="readonlyMode"
      />
    }

    <div class="steps-action">
      <div class="left-actions">
        <button
          nz-button
          nzType="default"
          (click)="pre($event)"
          [disabled]="!(current > 0)"
          class="previous"
        >
          <span>{{ "Previous" | translate }}</span>
        </button>
        <button
          nz-button
          nzType="default"
          (click)="next($event)"
          [disabled]="!(current < pages.length - 1)"
        >
          <span>{{ "Next" | translate }}</span>
        </button>
      </div>
      <div class="right-actions" *hasAddPermissions="['a-sqa']">
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzDanger
            class="cancel-btn"
            type="button"
            (click)="revertForm()"
            [disabled]="!hasChanges"
          >
            <span>{{ "Revert" | translate }}</span>
          </button>
        }
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzType="primary"
            type="submit"
            [disabled]="!hasChanges"
          >
            <span>{{ "Submit" | translate }}</span>
          </button>
        }
      </div>
    </div>
  </form>
}

@if (isLoading) {
  <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
}
